/*
 * Why does this component exist? Good question.
 *
 * When a button is not intended to submit a form, it should carry
 *  type="button". Otherwise, it will cause errant form submissions
 *  depending on what browser, you're using.
 *
 * This has happened in the past and will continue to happen in the future. If
 *  you want to submit a form, use Submit or ThrobbingSubmit.
 */

import React from 'react'

const Button = (props) => <button type="button" {...props} />

export default Button
